export default "__VITE_ASSET__1fd649ab__"